export default __webpack_public_path__ + "static/media/DNo.27-5.09c104bc.jpg";